(function () {
  var overlay = document.querySelector('[data-isf-cart-overlay]');
  var drawer = document.querySelector('[data-isf-cart-drawer]');
  if (!overlay || !drawer) return;

  var itemsEl = drawer.querySelector('[data-isf-cart-items]');
  var emptyEl = drawer.querySelector('[data-isf-cart-empty]');
  var countEl = drawer.querySelector('[data-isf-cart-count]');
  var subtotalEl = drawer.querySelector('[data-isf-cart-subtotal]');
  var footEl = drawer.querySelector('[data-isf-cart-foot]');
  var shipEl = drawer.querySelector('[data-isf-cart-ship]');
  var shipMsgEl = drawer.querySelector('[data-isf-cart-ship-msg]');
  var shipFillEl = drawer.querySelector('[data-isf-cart-ship-fill]');
  var shipIconEl = drawer.querySelector('[data-isf-cart-ship-icon]');
  var shipStatusEl = drawer.querySelector('[data-isf-cart-ship-status]');
  var upsellEl = drawer.querySelector('[data-isf-cart-upsell]');
  var upsellListEl = drawer.querySelector('[data-isf-cart-upsell-list]');
  var recentEl = drawer.querySelector('[data-isf-cart-recent]');
  var recentListEl = drawer.querySelector('[data-isf-cart-recent-list]');
  var lastFocus = null;
  var lastProductId = null;
  var lastCart = null;
  var busy = false;
  var wasUnlocked = false;
  var lockY = 0;
  var RV_KEY = 'isfRecentlyViewed';

  function shopCurrencyCode() {
    return drawer.getAttribute('data-shop-currency') || 'USD';
  }

  function cartCurrencyCode() {
    if (lastCart && lastCart.currency) return lastCart.currency;
    if (window.Shopify && Shopify.currency && Shopify.currency.active) return Shopify.currency.active;
    if (window.Currency && Currency.currentCurrency) return Currency.currentCurrency;
    return shopCurrencyCode();
  }

  function hasDomPriceConverter() {
    return !!(
      window.Transcy ||
      window.transcy ||
      window.TranscyApp ||
      document.querySelector('script[src*="transcy"]') ||
      document.querySelector('[class*="transcy"]') ||
      (window.Currency && typeof Currency.convertAll === 'function') ||
      typeof window.convertCurrencies === 'function'
    );
  }

  function moneyFormatFor(code) {
    var shop = shopCurrencyCode();
    if (code === shop && window.theme && theme.moneyFormat) return theme.moneyFormat;
    if (code && window.Currency && Currency.moneyFormats && Currency.moneyFormats[code]) {
      return Currency.moneyFormats[code].money_format;
    }
    return (window.theme && theme.moneyFormat) || '${{amount}}';
  }

  function formatMoneyAmount(cents, code) {
    var amount = Number(cents) || 0;
    var format = moneyFormatFor(code);
    try {
      if (window.theme && theme.Currency && theme.Currency.formatMoney) {
        return theme.Currency.formatMoney(amount, format);
      }
    } catch (e) {}
    return '$' + (amount / 100).toFixed(2);
  }

  function presentmentCents(shopCents) {
    var cents = Number(shopCents) || 0;
    var shop = shopCurrencyCode();
    var cartCur = cartCurrencyCode();
    if (cartCur !== shop) return cents;
    if (hasDomPriceConverter()) return cents;
    if (window.Shopify && Shopify.currency && Shopify.currency.active && Shopify.currency.active !== shop) {
      var rate = parseFloat(Shopify.currency.rate);
      if (rate > 0) return Math.round(cents * rate);
    }
    return cents;
  }

  function money(cents) {
    var shop = shopCurrencyCode();
    var cartCur = cartCurrencyCode();
    if (cartCur !== shop) return formatMoneyAmount(cents, cartCur);
    if (hasDomPriceConverter()) return formatMoneyAmount(cents, shop);
    var active = (window.Shopify && Shopify.currency && Shopify.currency.active) || shop;
    return formatMoneyAmount(presentmentCents(cents), active);
  }

  function moneyHtml(cents) {
    var shop = shopCurrencyCode();
    var cartCur = cartCurrencyCode();
    var formatted = money(cents);
    if (cartCur === shop) {
      return (
        '<span class="money" data-currency-' +
        shop +
        '="' +
        escapeHtml(formatted) +
        '">' +
        formatted +
        '</span>'
      );
    }
    return '<span>' + formatted + '</span>';
  }

  function applyStoreCurrency() {
    if (lastCart && lastCart.currency && lastCart.currency !== shopCurrencyCode()) return;
    try {
      if (typeof window.convertCurrencies === 'function') window.convertCurrencies();
    } catch (e) {}
    try {
      if (window.Currency && typeof Currency.convertAll === 'function') {
        var from = shopCurrencyCode();
        var to =
          Currency.currentCurrency ||
          (Currency.cookie && Currency.cookie.read && Currency.cookie.read()) ||
          (window.Shopify && Shopify.currency && Shopify.currency.active);
        if (from && to && from !== to) Currency.convertAll(from, to);
      }
    } catch (e) {}
    try {
      var api = window.Transcy || window.transcy || window.TranscyApp;
      if (api) {
        if (typeof api.updatePrice === 'function') api.updatePrice();
        if (typeof api.reloadPrice === 'function') api.reloadPrice();
        if (typeof api.updateAllPrices === 'function') api.updateAllPrices();
        if (typeof api.convert === 'function') api.convert();
        if (typeof api.reconvert === 'function') api.reconvert();
      }
      document.dispatchEvent(new CustomEvent('transcy:updated'));
      document.dispatchEvent(new Event('transcy:reload'));
      if (window.jQuery) {
        window.jQuery(document).trigger('transcy.reload');
        window.jQuery(document).trigger('currency:update');
      }
    } catch (e) {}
  }

  function shipThresholdCents() {
    var raw = (drawer.getAttribute('data-ship-threshold') || '75').replace(/[^0-9.]/g, '');
    var dollars = parseFloat(raw);
    if (!dollars || dollars <= 0) dollars = 75;
    return Math.round(dollars * 100);
  }

  function thresholdInCartCents(cart) {
    var threshold = shipThresholdCents();
    var shop = shopCurrencyCode();
    var cartCur = (cart && cart.currency) || shop;
    if (cartCur === shop) return threshold;
    var rate = 1;
    if (window.Shopify && Shopify.currency && Shopify.currency.rate) {
      rate = parseFloat(Shopify.currency.rate) || 1;
    }
    return Math.round(threshold * rate);
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function sizedImage(src, size) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_' + size + '$1$2');
  }

  function itemImage(item) {
    return sizedImage(item.image || item.featured_image || '', '120x');
  }

  function productImage(p) {
    if (!p) return '';
    if (typeof p.featured_image === 'string') return p.featured_image;
    if (p.featured_image && p.featured_image.src) return p.featured_image.src;
    if (p.images && p.images[0]) {
      return typeof p.images[0] === 'string' ? p.images[0] : p.images[0].src;
    }
    if (p.image) return p.image;
    return '';
  }

  function pickVariant(product) {
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) return variants[i];
    }
    return variants[0] || null;
  }

  var FLOATING_HIDE_SEL =
    'shopify-chat, #dummy-chat-button-iframe, iframe[name="preview-notification"],' +
    '[id*="review-tab"], [id*="review_tab"], [class*="review-tab"], [class*="review_tab"],' +
    '[class*="ReviewTab"], [class*="alr-wh-rw-popup"]';

  function setFloatingWidgets(hide) {
    var nodes = document.querySelectorAll(FLOATING_HIDE_SEL);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.closest && (el.closest('.alireviews-review-box') || el.closest('.isf-pdp__reviews'))) continue;
      if (hide) {
        el.setAttribute('data-isf-cart-hidden', '');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
      } else if (el.hasAttribute('data-isf-cart-hidden')) {
        el.removeAttribute('data-isf-cart-hidden');
        el.style.removeProperty('visibility');
        el.style.removeProperty('opacity');
        el.style.removeProperty('pointer-events');
      }
    }
  }

  function lockScroll() {
    lockY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('isf-cart-open');
    document.body.classList.add('isf-cart-open');
    setFloatingWidgets(true);
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + lockY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.style.overscrollBehavior = 'none';
  }

  function unlockScroll() {
    document.documentElement.classList.remove('isf-cart-open');
    document.body.classList.remove('isf-cart-open');
    setFloatingWidgets(false);
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    document.documentElement.style.overscrollBehavior = '';
    window.scrollTo(0, lockY);
  }

  function onTouchMove(evt) {
    if (!document.body.classList.contains('isf-cart-open')) return;
    var scroll = evt.target.closest && evt.target.closest('[data-isf-cart-scroll]');
    if (!scroll) {
      evt.preventDefault();
      return;
    }
    if (scroll.scrollHeight <= scroll.clientHeight) {
      evt.preventDefault();
    }
  }

  function updateHeader(cart) {
    var badge = document.getElementById('CartCount');
    if (badge) {
      var inner = badge.querySelector('span') || badge;
      inner.textContent = String(cart.item_count || 0);
      if (cart.item_count > 0) badge.classList.remove('hide');
      else badge.classList.add('hide');
    }
    var cost = document.getElementById('CartCost');
    if (cost) cost.innerHTML = moneyHtml(cart.total_price);
  }

  function renderShip(cart) {
    if (!shipEl) return;
    var threshold = thresholdInCartCents(cart);
    var total = (cart && cart.total_price) || 0;
    var remaining = Math.max(0, threshold - total);
    var pct = threshold ? Math.min(100, Math.round((total / threshold) * 100)) : 0;
    var unlocked = remaining <= 0 && total > 0;

    shipEl.hidden = false;
    shipEl.classList.toggle('is-unlocked', unlocked);

    var dest = unlocked ? 100 : pct;
    if (shipFillEl) shipFillEl.style.width = dest + '%';
    if (shipIconEl) {
      var nextLeft = dest + '%';
      var prevLeft = shipIconEl.style.left;
      if (
        drawer.classList.contains('is-open') &&
        prevLeft !== nextLeft &&
        (prevLeft || dest > 0)
      ) {
        shipEl.classList.add('is-rolling');
        window.clearTimeout(shipEl._isfRollTimer);
        shipEl._isfRollTimer = window.setTimeout(function () {
          shipEl.classList.remove('is-rolling');
        }, 320);
      }
      shipIconEl.style.left = nextLeft;
    }

    if (shipMsgEl) {
      if (unlocked) {
        shipMsgEl.innerHTML =
          'Free shipping unlocked <span class="isf-cart-drawer__ship-emoji" aria-hidden="true">🎉</span>';
      } else if (total > 0) {
        shipMsgEl.innerHTML =
          'You’re <span class="isf-cart-drawer__ship-amt">' +
          moneyHtml(remaining) +
          '</span> away from free shipping';
      } else {
        shipMsgEl.innerHTML =
          'Free shipping on orders over <span class="isf-cart-drawer__ship-amt">' +
          moneyHtml(threshold) +
          '</span>';
      }
    }
    if (shipStatusEl) {
      shipStatusEl.textContent = unlocked ? 'FREE' : 'Calculated at checkout';
      shipStatusEl.classList.toggle('is-free', unlocked);
    }

    if (unlocked && !wasUnlocked) {
      shipEl.classList.remove('is-just-unlocked');
      void shipEl.offsetWidth;
      shipEl.classList.add('is-just-unlocked');
    }
    wasUnlocked = unlocked;
  }

  function renderItems(cart) {
    if (!itemsEl) return;
    var items = cart.items || [];
    itemsEl.innerHTML = '';
    if (countEl) {
      if (cart.item_count === 1) countEl.textContent = '1 item';
      else countEl.textContent = (cart.item_count || 0) + ' items';
    }
    if (subtotalEl) subtotalEl.innerHTML = moneyHtml(cart.total_price);
    if (emptyEl) emptyEl.hidden = items.length > 0;
    if (footEl) footEl.hidden = items.length === 0;
    itemsEl.hidden = items.length === 0;

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var img = itemImage(item);
      var variant =
        item.variant_title && item.variant_title !== 'Default Title'
          ? '<div class="isf-cart-drawer__variant">' + escapeHtml(item.variant_title) + '</div>'
          : '';
      var li = document.createElement('li');
      li.className = 'isf-cart-drawer__item';
      li.innerHTML =
        '<a class="isf-cart-drawer__thumb" href="' + escapeHtml(item.url || '#') + '">' +
          (img
            ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(item.product_title || item.title) + '" width="72" height="72">'
            : '') +
        '</a>' +
        '<div class="isf-cart-drawer__meta">' +
          '<div class="isf-cart-drawer__item-top">' +
            '<a class="isf-cart-drawer__name" href="' + escapeHtml(item.url || '#') + '">' +
              escapeHtml(item.product_title || item.title) +
            '</a>' +
            '<span class="isf-cart-drawer__price">' + moneyHtml(item.final_line_price || item.line_price) + '</span>' +
          '</div>' +
          variant +
            '<div class="isf-cart-drawer__item-bot">' +
            '<div class="isf-cart-drawer__qty" role="group" aria-label="Quantity">' +
              '<button type="button" data-isf-cart-change data-key="' + escapeHtml(item.key) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-isf-cart-change data-key="' + escapeHtml(item.key) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button type="button" class="isf-cart-drawer__remove" data-isf-cart-change data-key="' + escapeHtml(item.key) + '" data-qty="0" aria-label="Remove">' +
              '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
                '<polyline points="3 6 5 6 21 6"/>' +
                '<path d="M8 6V4.8A1.8 1.8 0 0 1 9.8 3h4.4A1.8 1.8 0 0 1 16 4.8V6"/>' +
                '<path d="M19 6l-.7 12.2A2 2 0 0 1 16.3 20H7.7a2 2 0 0 1-2-1.8L5 6"/>' +
                '<line x1="10" y1="11" x2="10" y2="16"/>' +
                '<line x1="14" y1="11" x2="14" y2="16"/>' +
              '</svg>' +
            '</button>' +
          '</div>' +
        '</div>';
      itemsEl.appendChild(li);
    }
  }

  function cartIds(cart) {
    var ids = {};
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      ids[String(items[i].product_id)] = true;
    }
    return ids;
  }

  function recCard(p, v, imgSize) {
    var img = sizedImage(productImage(p), imgSize);
    var price = p.price;
    if (typeof price !== 'number' && v && v.price) price = v.price;
    return (
      '<article class="isf-cart-drawer__upsell-item">' +
        '<a class="isf-cart-drawer__upsell-thumb" href="/products/' + escapeHtml(p.handle) + '">' +
          (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.title) + '" width="56" height="56">' : '') +
        '</a>' +
        '<div class="isf-cart-drawer__upsell-meta">' +
          '<a href="/products/' + escapeHtml(p.handle) + '">' + escapeHtml(p.title) + '</a>' +
          '<span>' + moneyHtml(price) + '</span>' +
        '</div>' +
        '<button type="button" class="isf-cart-drawer__add" data-isf-cart-add="' + v.id + '" data-product-id="' + p.id + '">Add</button>' +
      '</article>'
    );
  }

  function renderUpsell(products, cart) {
    if (!upsellEl || !upsellListEl) return;
    var inCart = cartIds(cart);
    var picked = [];
    for (var i = 0; i < products.length && picked.length < 2; i++) {
      var p = products[i];
      if (!p || inCart[String(p.id)]) continue;
      var v = pickVariant(p);
      if (!v || v.available === false) continue;
      picked.push({ product: p, variant: v });
    }
    if (!picked.length) {
      upsellEl.hidden = true;
      upsellListEl.innerHTML = '';
      return;
    }
    upsellEl.hidden = false;
    upsellListEl.innerHTML = picked
      .map(function (row) {
        return recCard(row.product, row.variant, '80x');
      })
      .join('');
  }

  function readRecent() {
    try {
      var raw = window.localStorage.getItem(RV_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function writeRecent(list) {
    try {
      window.localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 8)));
    } catch (e) {}
  }

  function trackViewed() {
    var jsonEl = document.querySelector('[id^="ProductJson-"]');
    if (!jsonEl || !jsonEl.textContent) return;
    var p;
    try {
      p = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }
    if (!p || !p.id || !p.handle) return;
    var v = pickVariant(p);
    var entry = {
      id: p.id,
      handle: p.handle,
      title: p.title,
      price: p.price,
      image: productImage(p),
      variantId: v ? v.id : null,
      available: !v || v.available !== false
    };
    var list = readRecent().filter(function (item) {
      return String(item.id) !== String(p.id);
    });
    list.unshift(entry);
    writeRecent(list);
  }

  function renderRecent(cart) {
    if (!recentEl || !recentListEl) return;
    var inCart = cartIds(cart);
    var list = readRecent().filter(function (item) {
      return item && item.handle && item.variantId && !inCart[String(item.id)];
    }).slice(0, 4);
    if (!list.length) {
      recentEl.hidden = true;
      recentListEl.innerHTML = '';
      return;
    }
    recentEl.hidden = false;
    recentListEl.innerHTML = list
      .map(function (item) {
        var p = {
          id: item.id,
          handle: item.handle,
          title: item.title,
          price: item.price,
          featured_image: item.image
        };
        var v = { id: item.variantId, available: item.available !== false };
        return recCard(p, v, '80x');
      })
      .join('');
  }

  function loadUpsell(cart) {
    if (!upsellEl) return Promise.resolve();
    var items = (cart && cart.items) || [];
    if (!items.length) {
      upsellEl.hidden = true;
      return Promise.resolve();
    }
    var productId = lastProductId || items[items.length - 1].product_id;
    function request(intent) {
      return fetch(
        '/recommendations/products.json?product_id=' +
          encodeURIComponent(productId) +
          '&limit=8&intent=' +
          intent,
        { credentials: 'same-origin' }
      ).then(function (res) {
        if (!res.ok) return { products: [] };
        return res.json();
      });
    }
    return request('complementary')
      .then(function (data) {
        var products = (data && data.products) || [];
        if (products.length) return products;
        return request('related').then(function (alt) {
          return (alt && alt.products) || [];
        });
      })
      .then(function (products) {
        renderUpsell(products, cart);
      })
      .catch(function () {
        upsellEl.hidden = true;
      });
  }

  function paintCart(cart) {
    lastCart = cart;
    renderItems(cart);
    renderShip(cart);
    updateHeader(cart);
    renderRecent(cart);
    applyStoreCurrency();
    window.requestAnimationFrame(applyStoreCurrency);
  }

  function refresh() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        paintCart(cart);
        loadUpsell(cart).then(function () {
          applyStoreCurrency();
        });
        return cart;
      });
  }

  function setBusy(on) {
    busy = !!on;
    drawer.classList.toggle('is-busy', busy);
    drawer.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function changeQty(key, qty) {
    if (busy) return;
    setBusy(true);
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (cart && cart.status && cart.description) {
          throw new Error(cart.description);
        }
        paintCart(cart);
        setBusy(false);
        return loadUpsell(cart).then(function () {
          applyStoreCurrency();
        });
      })
      .catch(function () {})
      .then(function () {
        setBusy(false);
      });
  }

  function addVariant(id, productId) {
    if (busy) return Promise.reject(new Error('busy'));
    setBusy(true);
    if (productId) lastProductId = productId;
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function () {
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (res) {
          return res.json();
        });
      })
      .then(function (cart) {
        paintCart(cart);
        setBusy(false);
        return loadUpsell(cart).then(function () {
          applyStoreCurrency();
          return cart;
        });
      })
      .catch(function (err) {
        setBusy(false);
        throw err;
      });
  }

  function addAndOpen(id, productId) {
    return addVariant(id, productId).then(function (cart) {
      open({ added: { product_id: productId } });
      return cart;
    });
  }

  function focusables() {
    return drawer.querySelectorAll(
      'button:not([disabled]), a[href], input:not([disabled])'
    );
  }

  function open(opts) {
    opts = opts || {};
    if (opts.added && opts.added.product_id) lastProductId = opts.added.product_id;
    lastFocus = document.activeElement;
    overlay.hidden = false;
    drawer.hidden = false;
    lockScroll();
    var triggers = document.querySelectorAll('[data-isf-cart-open]');
    for (var t = 0; t < triggers.length; t++) triggers[t].setAttribute('aria-expanded', 'true');
    window.requestAnimationFrame(function () {
      overlay.classList.add('is-open');
      drawer.classList.add('is-open');
    });
    var closeBtn = drawer.querySelector('[data-isf-cart-close]');
    if (closeBtn) closeBtn.focus();
    refresh();
  }

  function close() {
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    unlockScroll();
    var triggers = document.querySelectorAll('[data-isf-cart-open]');
    for (var t = 0; t < triggers.length; t++) triggers[t].setAttribute('aria-expanded', 'false');
    window.setTimeout(function () {
      overlay.hidden = true;
      drawer.hidden = true;
    }, 180);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  overlay.addEventListener('click', close);
  overlay.addEventListener('wheel', function (evt) { evt.preventDefault(); }, { passive: false });
  document.addEventListener('touchmove', onTouchMove, { passive: false });
  if (shipIconEl) {
    shipIconEl.addEventListener('transitionend', function (evt) {
      if (evt.propertyName !== 'left') return;
      shipEl.classList.remove('is-rolling');
    });
  }

  drawer.addEventListener('click', function (evt) {
    if (evt.target.closest('[data-isf-cart-close]')) {
      evt.preventDefault();
      close();
    }
  });

  function isCartPageHref(href) {
    if (!href || href.charAt(0) === '#') return false;
    var path;
    try {
      var u = new URL(href, window.location.origin);
      if (u.origin !== window.location.origin) return false;
      path = u.pathname;
    } catch (e) {
      path = String(href).split('?')[0].split('#')[0];
    }
    path = path.replace(/\/+$/, '') || '/';
    return /(?:^|\/)cart$/.test(path);
  }

  function consumeCartIntent() {
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      params = null;
    }
    var fromQuery = params && params.get('isfCart') === '1';
    var fromStore = false;
    try {
      fromStore = sessionStorage.getItem('isfOpenCart') === '1';
      sessionStorage.removeItem('isfOpenCart');
    } catch (err) {}
    if (!fromQuery && !fromStore) return;
    if (fromQuery && params) {
      params.delete('isfCart');
      var qs = params.toString();
      var next = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
      if (window.history && history.replaceState) history.replaceState({}, '', next);
    }
    open();
  }

  document.addEventListener('click', function (evt) {
    var trigger = evt.target.closest && evt.target.closest('[data-isf-cart-open]');
    var link = evt.target.closest && evt.target.closest('a[href]');
    if (trigger) {
      evt.preventDefault();
      open();
      return;
    }
    if (link && isCartPageHref(link.getAttribute('href'))) {
      evt.preventDefault();
      open();
    }
  }, true);

  document.addEventListener('keydown', function (evt) {
    if (!document.body.classList.contains('isf-cart-open')) return;
    if (evt.key === 'Escape') {
      evt.preventDefault();
      close();
      return;
    }
    if (evt.key !== 'Tab') return;
    var nodes = focusables();
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (evt.shiftKey && document.activeElement === first) {
      evt.preventDefault();
      last.focus();
    } else if (!evt.shiftKey && document.activeElement === last) {
      evt.preventDefault();
      first.focus();
    }
  });

  drawer.addEventListener('click', function (evt) {
    var change = evt.target.closest('[data-isf-cart-change]');
    if (change) {
      evt.preventDefault();
      changeQty(change.getAttribute('data-key'), parseInt(change.getAttribute('data-qty'), 10) || 0);
      return;
    }
    var add = evt.target.closest('[data-isf-cart-add]');
    if (add) {
      evt.preventDefault();
      addVariant(add.getAttribute('data-isf-cart-add'), add.getAttribute('data-product-id')).catch(function () {});
    }
  });

  document.addEventListener('click', function (evt) {
    var cardAdd = evt.target.closest && evt.target.closest('[data-isf-card-add]');
    if (!cardAdd) return;
    evt.preventDefault();
    evt.stopPropagation();
    if (cardAdd.disabled) return;
    var vid = cardAdd.getAttribute('data-variant-id');
    var pid = cardAdd.getAttribute('data-product-id');
    if (!vid) return;
    cardAdd.disabled = true;
    cardAdd.classList.add('is-busy');
    addAndOpen(vid, pid)
      .then(function () {
        cardAdd.classList.remove('is-busy');
        cardAdd.classList.add('is-added');
        window.setTimeout(function () {
          cardAdd.classList.remove('is-added');
          cardAdd.disabled = false;
        }, 1400);
      })
      .catch(function () {
        cardAdd.classList.remove('is-busy');
        cardAdd.disabled = false;
      });
  });

  try {
    var boot = document.getElementById('IsfCartBoot');
    if (boot && boot.textContent) {
      var cart = JSON.parse(boot.textContent);
      paintCart(cart);
    }
  } catch (e) {}

  trackViewed();

  window.IsfCartDrawer = {
    open: open,
    close: close,
    refresh: refresh,
    addAndOpen: addAndOpen
  };

  consumeCartIntent();
})();
